import { z } from "zod";

export const ModelMarketingContentSchema = z.object({
  content: z.string(),
});

export type ModelMarketingContent = z.infer<typeof ModelMarketingContentSchema>;
